// Common
import React from 'react';

// Moment
import moment from 'moment';
import 'moment/locale/ru';

// Data
// import data from './data/data';  // закоментил чтобы не вылетали варнинги
// import data_archive from './data/data_archive'; // закоментил чтобы не вылетали варнинги
// import output from './data/output'; // закоментил чтобы не вылетали варнинги

// Ant
import { Button, DatePicker, Tooltip } from 'antd';

/*  // закоментил чтобы не вылетали варнинги
const { Text } = Typography;
const { Option } = Select;
const confirm = Modal.confirm;
const Search = Input.Search;
const InputGroup = Input.Group;
const { RangePicker } = DatePicker;
*/

moment.locale('ru');

class DateRender extends React.Component {
  render() {
    let current = this.props.current;
    // let today = this.props.today;
    let output = this.props.output;
    let range_date = this.props.range_date;
    let select_day = this.props.select_day;
    let orders = this.props.orders;
    let state_output = output.filter(item => {
      if (
        moment(item.date).date() === current.date() &&
        moment(item.date).month() === current.month() &&
        moment(item.date).year() === current.year()
      ) {
        return true;
      }
      return false;
    });
    let from_range = range_date.filter(item => {
      if (
        moment(item).date() === current.date() &&
        moment(item).month() === current.month() &&
        moment(item).year() === current.year()
      ) {
        return current;
      }
      return false;
    });
    let from_select_day = select_day.filter(item => {
      if (
        moment(item).date() === current.date() &&
        moment(item).month() === current.month() &&
        moment(item).year() === current.year()
      ) {
        return current;
      }
      return false;
    });
    let state_orders =
      orders &&
      orders.filter(item => {
        if (
          moment(item.order.date_create).date() === current.date() &&
          moment(item.order.date_create).month() === current.month() &&
          moment(item.order.date_create).year() === current.year()
        ) {
          return true;
        }
        return false;
      });
    const style = {};
    if (state_output.length > 0) {
      if (
        state_output[0].type === 'output' &&
        current.unix() > moment().unix()
      ) {
        style.color = '#f5222d';
      }
      if (
        state_output[0].type === 'output' &&
        current.unix() < moment().unix()
      ) {
        style.border = 'solid 1px #9b9b9b';
        style.borderRadius = '50% 50%';
        style.width = '24px';
      }
    }
    if (from_range.length > 0) {
      style.backgroundColor = 'rgba(0, 168, 255, .1)';
    }
    if (from_select_day.length > 0 && this.props.type === 'output') {
      style.color = '#f5222d';
      style.backgroundColor = 'rgba(245, 34, 45, 0.1)';
    }
    if (
      state_orders &&
      state_orders.length > 0 &&
      current.unix() > moment().unix()
    ) {
      style.color = '#00a8ff';
    }
    return (
      <div className="ant-calendar-date" style={style}>
        {(state_orders.length > 0 && this.props.type === 'output' && (
          <Tooltip
            placement="topLeft"
            title={
              <span>
                <span>Внимание!</span>Вы не можете отметить в качестве не
                рабочего дня день заказа. Смените водителя на заказах в данный
                день.
              </span>
            }
            trigger="click"
            overlayClassName="tooltip tooltip_custom"
          >
            <span>{current.date()}</span>
          </Tooltip>
        )) ||
          current.date()}
      </div>
    );
  }
}

class ThreeDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prevdate: -1,
      currentdate: 0,
      nextdate: 1,
      range_date: [],
      select_day: [],
    };
  }
  componentDidMount() {}

  enumerateDaysBetweenDates(startDate, endDate) {
    var dates = [];

    var currDate = moment(startDate).startOf('day');
    var lastDate = moment(endDate).startOf('day');

    while (currDate.add(1, 'days').diff(lastDate) < 0) {
      dates.push(currDate.clone().toDate());
    }

    return dates;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.date_range !== prevProps.date_range) {
      if (
        this.props.date_range[0] > 0 &&
        this.props.date_range[1] < 99999999999999
      ) {
        this.setState((state, props) => ({
          range_date: this.enumerateDaysBetweenDates(
            this.props.date_range[0],
            this.props.date_range[1]
          ),
        }));
      } else {
        this.setState((state, props) => ({
          range_date: [],
        }));
      }
    }

    if (this.props.selected_days !== prevProps.selected_days) {
      if (!this.props.selected_days.length) {
        this.setState((state, props) => ({
          select_day: [],
        }));
      } else {
        this.setState((state, props) => ({
          select_day: this.props.selected_days,
        }));
      }
    }
  }
  // Предыдущий год
  prevYear = () => {
    this.setState((state, props) => ({
      prevdate: this.state.prevdate - 12,
      currentdate: this.state.currentdate - 12,
      nextdate: this.state.nextdate - 12,
    }));
  };

  // Предыдущий месяц
  prevMonth = () => {
    this.setState((state, props) => ({
      prevdate: this.state.prevdate - 1,
      currentdate: this.state.currentdate - 1,
      nextdate: this.state.nextdate - 1,
    }));
  };

  // Следующий месяц
  nextMonth = () => {
    this.setState((state, props) => ({
      prevdate: this.state.prevdate + 1,
      currentdate: this.state.currentdate + 1,
      nextdate: this.state.nextdate + 1,
    }));
  };

  // Следующий год
  nextYear = () => {
    this.setState((state, props) => ({
      prevdate: this.state.prevdate + 12,
      currentdate: this.state.currentdate + 12,
      nextdate: this.state.nextdate + 12,
    }));
  };

  // Неактивные даты
  disabled_date(current) {
    return current && current.unix() < moment().unix() - 43200;
  }

  // Выбор дней
  select_days = (date, dateString) => {
    let orders = this.props.orders;
    let state_orders =
      orders &&
      orders.filter(item => {
        if (
          moment(item.order.date_create).date() === date.date() &&
          moment(item.order.date_create).month() === date.month() &&
          moment(item.order.date_create).year() === date.year()
        ) {
          return true;
        }
        return false;
      });
    let output = this.props.output;
    let state_output = output.filter(item => {
      if (
        moment(item.date).date() === date.date() &&
        moment(item.date).month() === date.month() &&
        moment(item.date).year() === date.year()
      ) {
        return true;
      }
      return false;
    });

    if (
      this.props.type === 'output' &&
      state_orders.length === 0 &&
      state_output.length === 0
    ) {
      let days = this.state.select_day;
      if (days.indexOf(dateString) < 0) {
        //let days_total = days.push(dateString);
        days.push(dateString);

        this.setState((state, props) => ({
          select_day: days,
        }));
        this.props.select_days(days);
      }
    }
  };

  render() {
    const { output } = this.props;
    const { orders } = this.props;
    const { range_date } = this.state;
    let select_day = this.state.select_day;

    return (
      <div className="auto-order__calendar">
        <div className="auto-order__calendar-header">
          <div>
            <Button
              type="link"
              shape="circle"
              onClick={this.prevYear}
              icon="double-left"
            />
            <Button
              type="link"
              shape="circle"
              onClick={this.prevMonth}
              icon="left"
            />
          </div>
          <div>
            <Button
              type="link"
              shape="circle"
              onClick={this.nextMonth}
              icon="right"
            />
            <Button
              type="link"
              shape="circle"
              onClick={this.nextYear}
              icon="double-right"
            />
          </div>
        </div>
        <div className="auto-order__three-calendar">
          <DatePicker
            open={true}
            className="cart-employee__datepicker"
            disabledDate={this.disabled_date}
            value={moment().add(this.state.prevdate, 'month')}
            onChange={this.select_days}
            getCalendarContainer={trigger => {
              let div = document.createElement('div');
              return (div.innerHTML = trigger);
            }}
            dateRender={(current, today) => (
              <DateRender
                orders={orders}
                type={this.props.type}
                current={current}
                today={today}
                output={output}
                range_date={range_date}
                select_day={select_day}
              />
            )}
          />
          <DatePicker
            open={true}
            className="cart-employee__datepicker"
            disabledDate={this.disabled_date}
            value={moment().add(this.state.currentdate, 'month')}
            onChange={this.select_days}
            getCalendarContainer={trigger => {
              let div = document.createElement('div');
              return (div.innerHTML = trigger);
            }}
            dateRender={(current, today) => (
              <DateRender
                orders={orders}
                type={this.props.type}
                current={current}
                today={today}
                output={output}
                range_date={range_date}
                select_day={select_day}
              />
            )}
          />
          <DatePicker
            open={true}
            className="cart-employee__datepicker"
            disabledDate={this.disabled_date}
            value={moment().add(this.state.nextdate, 'month')}
            onChange={this.select_days}
            getCalendarContainer={trigger => {
              let div = document.createElement('div');
              return (div.innerHTML = trigger);
            }}
            dateRender={(current, today) => (
              <DateRender
                orders={orders}
                type={this.props.type}
                current={current}
                today={today}
                output={output}
                range_date={range_date}
                select_day={select_day}
              />
            )}
          />
        </div>
      </div>
    );
  }
}

export default ThreeDatePicker;
